const ActionTypes = {
  REHYDRATE: 'persist/REHYDRATE',
  PRESELECT_INITIAL_VALUES: 'gc/PRESELECT_INITIAL_VALUES',
  FETCH_SELECTION_REQUEST: 'gc/FETCH_SELECTION_REQUEST',
  FETCH_SELECTION_SUCCESS: 'gc/FETCH_SELECTION_SUCCESS',
  FETCH_SELECTION_ERROR: 'gc/FETCH_SELECTION_ERROR',
  ITEM_ADD_REQUEST: 'gc/ITEM_ADD_REQUEST',
  ITEM_ADD_SUCCESS: 'gc/ITEM_ADD_SUCCESS',
  LINE_ITEM_ADD_REQUEST: 'gc/LINE_ITEM_ADD_REQUEST',
  LINE_ITEM_ADD_SUCCESS: 'gc/LINE_ITEM_ADD_SUCCESS',
  LINE_ITEM_ADD_ERROR: 'gc/LINE_ITEM_ADD_ERROR',
  LINE_ITEM_REMOVE_REQUEST: 'gc/LINE_ITEM_REMOVE_REQUEST',
  LINE_ITEM_REMOVE_SUCCESS: 'gc/LINE_ITEM_REMOVE_SUCCESS',
  LINE_ITEM_REMOVE_ERROR: 'gc/LINE_ITEM_REMOVE_ERROR',
  ITEM_REMOVE_REQUEST: 'gc/ITEM_REMOVE_REQUEST',
  ITEM_REMOVE_SUCCESS: 'gc/ITEM_REMOVE_SUCCESS',
  FETCH_KCO_WIDGET_REQUEST: 'gc/FETCH_KCO_WIDGET_REQUEST',
  FETCH_KCO_WIDGET_SUCCESS: 'gc/FETCH_KCO_WIDGET_SUCCESS',
  FETCH_KCO_WIDGET_CANCEL: 'gc/FETCH_KCO_WIDGET_CANCEL',
  FETCH_WIDGET_REQUEST: 'gc/FETCH_WIDGET_REQUEST',
  FETCH_WIDGET_SUCCESS: 'gc/FETCH_WIDGET_SUCCESS',
  CHANGE_STEP_REQUEST: 'gc/CHANGE_STEP_REQUEST',
  CHANGE_STEP_SUCCESS: 'gc/CHANGE_STEP_SUCCESS',
  SET_STEP_TITLE: 'gc/SET_STEP_TITLE',
  HANDLE_SHIPWALLET_STEP_REQUEST: 'gc/HANDLE_SHIPWALLET_STEP_REQUEST',
  HANDLE_SHIPWALLET_STEP_SUCCESS: 'gc/HANDLE_SHIPWALLET_STEP_SUCCESS',
  COUNTRY_CHANGE_REQUEST: 'gc/COUNTRY_CHANGE_REQUEST',
  COUNTRY_CHANGE_SUCCESS: 'gc/COUNTRY_CHANGE_SUCCESS',
  COUNTRY_CHANGE_CANCEL: 'gc/COUNTRY_CHANGE_CANCEL',
  COUNTRY_STATE_CHANGE_REQUEST: 'gc/COUNTRY_STATE_CHANGE_REQUEST',
  COUNTRY_STATE_CHANGE_SUCCESS: 'gc/COUNTRY_STATE_CHANGE_SUCCESS',
  PAYMENT_RESULT_REQUEST: 'gc/PAYMENT_RESULT_REQUEST',
  PAYMENT_RESULT_SUCCESS: 'gc/PAYMENT_RESULT_SUCCESS',
  PAYMENT_RESULT_ERROR: 'gc/PAYMENT_RESULT_ERROR',
  PAYMENT_RESULT_FAILURE: 'gc/PAYMENT_RESULT_FAILURE',
  UPDATE_PAYMENT_FIELDS_REQUEST: 'gc/UPDATE_PAYMENT_FIELDS_REQUEST',
  UPDATE_PAYMENT_FIELDS_SUCCESS: 'gc/UPDATE_PAYMENT_FIELDS_SUCCESS',
  UPDATE_NEWSLETTER_FIELD_REQUEST: 'gc/UPDATE_NEWSLETTER_FIELD_REQUEST',
  UPDATE_NEWSLETTER_FIELD_SUCCESS: 'gc/UPDATE_NEWSLETTER_FIELD_SUCCESS',
  RESPONSE_ERRORS: 'gc/RESPONSE_ERRORS',
  SET_ERRORS: 'gc/SET_ERRORS',
  RESET_ERRORS: 'gc/RESET_ERRORS',
  RESPONSE_NOTIFICATIONS: 'gc/RESPONSE_NOTIFICATIONS',
  RESET_NOTIFICATIONS: 'gc/RESET_NOTIFICATIONS',
  TOGGLE_CART_VISIBILITY: 'gc/TOGGLE_CART_VISIBILITY',
  CLOSE_CART: 'gc/CLOSE_CART',
  MOUSE_ENTER_CART: 'gc/MOUSE_ENTER_CART',
  OPEN_CART: 'gc/OPEN_CART',
  ADD_VOUCHER_REQUEST: 'gc/ADD_VOUCHER_REQUEST',
  ADD_VOUCHER_SUCCESS: 'gc/ADD_VOUCHER_SUCCESS',
  ADD_VOUCHER_ERROR: 'gc/ADD_VOUCHER_ERROR',
  REMOVE_VOUCHER_REQUEST: 'gc/REMOVE_VOUCHER_REQUEST',
  REMOVE_VOUCHER_SUCCESS: 'gc/REMOVE_VOUCHER_SUCCESS',
  REMOVE_VOUCHER_ERROR: 'gc/REMOVE_VOUCHER_ERROR',
  CLEAR_VOUCHER_ERROR: 'gc/CLEAR_VOUCHER_ERROR',
  LOCALE_TRANSLATIONS_FETCH_REQUEST: 'gc/LOCALE_TRANSLATIONS_FETCH_REQUEST',
  LOCALE_TRANSLATIONS_FETCH_SUCCESS: 'gc/LOCALE_TRANSLATIONS_FETCH_SUCCESS',
  LOCALE_TRANSLATIONS_FETCH_FALLBACK: 'gc/LOCALE_TRANSLATIONS_FETCH_FALLBACK',
  UPDATE_INTL_DATA: 'gc/UPDATE_INTL_DATA',
  CHANGE_MARKET_CONTEXT_REQUEST: 'gc/CHANGE_MARKET_CONTEXT_REQUEST',
  CHANGE_MARKET_CONTEXT_SUCCESS: 'gc/CHANGE_MARKET_CONTEXT_SUCCESS',
  CHANGE_SHIPPING_METHOD_REQUEST: 'gc/CHANGE_SHIPPING_METHOD_REQUEST',
  CHANGE_SHIPPING_METHOD_SUCCESS: 'gc/CHANGE_SHIPPING_METHOD_SUCCESS',
  CHANGE_PAYMENT_METHOD_REQUEST: 'gc/CHANGE_PAYMENT_METHOD_REQUEST',
  CHANGE_PAYMENT_METHOD_SUCCESS: 'gc/CHANGE_PAYMENT_METHOD_SUCCESS',
  INGRID_DELIVERY_OPTION_CHECK_REQUEST: 'gc/INGRID_DELIVERY_OPTION_CHECK_REQUEST',
  INGRID_DELIVERY_OPTION_CHECK_SUCCESS: 'gc/INGRID_DELIVERY_OPTION_CHECK_SUCCESS',
  CHECKOUT_REQUEST: 'gc/CHECKOUT_REQUEST',
  CHECKOUT_SUCCESS: 'gc/CHECKOUT_SUCCESS',
  SAVE_FORM_VALUES: 'gc/SAVE_FORM_VALUES',
  TOGGLE_ORDER_MESSAGE_VISIBILITY: 'gc/TOGGLE_ORDER_MESSAGE_VISIBILITY',
  SET_ORDER_MESSAGE_TEXT: 'gc/SET_ORDER_MESSAGE_TEXT',
  TOGGLE_MEMBERSHIP_OVERLAY: 'gc/TOGGLE_MEMBERSHIP_OVERLAY',
  LOG_IN_REQUEST: 'gc/LOG_IN_REQUEST',
  LOG_IN_SUCCESS: 'gc/LOG_IN_SUCCESS',
  LOG_IN_ERROR: 'gc/LOG_IN_ERROR',
  REGISTER_REQUEST: 'gc/REGISTER_REQUEST',
  REGISTER_SUCCESS: 'gc/REGISTER_SUCCESS',
  PASSWORD_RECOVERY_REQUEST: 'gc/PASSWORD_RECOVERY_REQUEST',
  PASSWORD_RECOVERY_SUCCESS: 'gc/PASSWORD_RECOVERY_SUCCESS',
  PASSWORD_RESET_REQUEST: 'gc/PASSWORD_RESET_REQUEST',
  PASSWORD_RESET_SUCCESS: 'gc/PASSWORD_RESET_SUCCESS',
  LOG_OUT_REQUEST: 'gc/LOG_OUT_REQUEST',
  LOG_OUT_SUCCESS: 'gc/LOG_OUT_SUCCESS',
  PASSWORD_CHANGE_REQUEST: 'gc/PASSWORD_CHANGE_REQUEST',
  PASSWORD_CHANGE_SUCCESS: 'gc/PASSWORD_CHANGE_SUCCESS',
  ACCOUNT_DETAILS_CHANGE_REQUEST: 'gc/ACCOUNT_DETAILS_CHANGE_REQUEST',
  ACCOUNT_DETAILS_CHANGE_SUCCESS: 'gc/ACCOUNT_DETAILS_CHANGE_SUCCESS',
  ACCOUNT_CHANEGE_TAB: 'gc/ACCOUNT_CHANEGE_TAB',
  PERSONAL_IDENTITY_NUMBER_FETCH_REQUEST: 'gc/PERSONAL_IDENTITY_NUMBER_FETCH_REQUEST',
  PERSONAL_IDENTITY_NUMBER_FETCH_SUCCESS: 'gc/PERSONAL_IDENTITY_NUMBER_FETCH_SUCCESS',
  ORDERS_HISTORY_REQUEST: 'gc/ORDERS_HISTORY_REQUEST',
  ORDERS_HISTORY_SUCCESS: 'gc/ORDERS_HISTORY_SUCCESS',
  CUSTOMER_CLUB_FETCH_REQUEST: 'gc/CUSTOMER_CLUB_FETCH_REQUEST',
  CUSTOMER_CLUB_FETCH_SUCCESS: 'gc/CUSTOMER_CLUB_FETCH_SUCCESS',
  CAMPAIGN_SITE_CHANGE_REQUEST: 'gc/CAMPAIGN_SITE_CHANGE_REQUEST',
  CAMPAIGN_SITE_CHANGE_SUCCESS: 'gc/CAMPAIGN_SITE_CHANGE_SUCCESS',
  FORCE_LOGOUT: 'gc/FORCE_LOGOUT',
};

export default ActionTypes;
